import Header from '../../components/header/header';
import Footer from '../../components/footer/footer';

function Universes() {
    return (
        <>
        <Header/>
        <Footer/>
        </>
    )
}

export default Universes;